<template>
  <div class="modal fade" :class="{ show: visible }" :style="{ display: visible ? 'block' : 'none' }" tabindex="-1" @click.self="close">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header border-danger">
          <h5 class="modal-title text-danger">
            <i class="bi bi-exclamation-triangle-fill me-2"></i>Ошибка
          </h5>
          <button type="button" class="btn-close" @click="close"></button>
        </div>
        <div class="modal-body">
          <div class="alert alert-danger mb-0">
            <div class="d-flex align-items-start gap-2">
              <i class="bi bi-x-circle-fill fs-4 flex-shrink-0"></i>
              <div class="flex-grow-1">
                <div class="fw-semibold mb-1">{{ title }}</div>
                <div class="small" style="white-space: pre-wrap;">{{ message }}</div>
                <div v-if="details" class="mt-2 pt-2 border-top border-danger" style="opacity: 0.8;">
                  <details>
                    <summary class="cursor-pointer small">Технические детали</summary>
                    <pre class="small mt-2 mb-0 text-muted" style="max-height: 200px; overflow-y: auto;">{{ details }}</pre>
                  </details>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" @click="close">Закрыть</button>
        </div>
      </div>
    </div>
  </div>
  <div v-if="visible" class="modal-backdrop fade show"></div>
</template>

<script>
export default {
  name: 'ErrorModal',
  data() {
    return {
      visible: false,
      title: 'Произошла ошибка',
      message: '',
      details: null,
    };
  },
  methods: {
    show(error) {
      // Извлекаем информацию из ошибки
      if (typeof error === 'string') {
        this.message = error;
        this.details = null;
      } else if (error?.userMessage) {
        this.message = error.userMessage;
        this.details = error.response ? JSON.stringify(error.response.data, null, 2) : null;
      } else if (error?.response?.data) {
        const data = error.response.data;
        this.message = data.message || data.error || 'Неизвестная ошибка';
        this.details = JSON.stringify(data, null, 2);
      } else if (error?.message) {
        this.message = error.message;
        this.details = error.stack || null;
      } else {
        this.message = 'Неизвестная ошибка';
        this.details = JSON.stringify(error, null, 2);
      }

      // Определяем заголовок по статусу
      if (error?.response?.status) {
        const status = error.response.status;
        if (status === 404) this.title = 'Не найдено';
        else if (status === 403) this.title = 'Доступ запрещён';
        else if (status === 422) this.title = 'Ошибка валидации';
        else if (status >= 500) this.title = 'Ошибка сервера';
        else this.title = `Ошибка ${status}`;
      } else {
        this.title = 'Произошла ошибка';
      }

      this.visible = true;
      document.body.classList.add('modal-open');
    },
    close() {
      this.visible = false;
      document.body.classList.remove('modal-open');
    },
  },
};
</script>

<style scoped>
.cursor-pointer {
  cursor: pointer;
}
details summary {
  user-select: none;
}
</style>
